module.exports = [{
      plugin: require('/fargate/6681f7ba/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
